import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=b5d5e32a&scoped=true&"
import script from "./HomeView.vue?vue&type=script&lang=ts&"
export * from "./HomeView.vue?vue&type=script&lang=ts&"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=b5d5e32a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d5e32a",
  null
  
)

export default component.exports